import { IDENTITY_PATHS } from '@hds/identity-client-sdk';

import BeginLoginPage from './BeginLoginPage.vue';
import AccountNotLinkedPage from './AccountNotLinkedPage.vue';
import WelcomePage from './WelcomePage.vue';
import LinkedLoginsPage from './LinkedLoginsPage.vue';
import LinkOutcomePage from './LinkOutcomePage.vue';

// The desktop identity route bindings, on the same shared identity paths the
// mobile bindings use. Spread into an app's vue-router `routes`; the app adds
// its own `name`/`meta` if it needs them (the platform administration app marks
// them `meta.identity` to render them outside its shell). `AccountNotLinkedPage`
// reads its `mode`/`providers` from the route query (the app populates them from
// routeForBootOutcome), so no per-route props here; `LinkOutcomePage` reads its
// `outcome`/`reason` the same way.
export const identityDesktopRoutes = [
    { path: IDENTITY_PATHS.login, component: BeginLoginPage },
    { path: IDENTITY_PATHS.accountNotLinked, component: AccountNotLinkedPage },
    { path: IDENTITY_PATHS.welcome, component: WelcomePage },
    { path: IDENTITY_PATHS.signInSecurity, component: LinkedLoginsPage },
    { path: IDENTITY_PATHS.linkOutcome, component: LinkOutcomePage }
];

export default identityDesktopRoutes;
